import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { requiredValidation } from 'validators';
import { Box, Column, Row, SegmentControl, TextField, Typography } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import { connectControllerToTextField } from '~/utils/react-hook-form.utils';
import styles from './ClientDetailsForm.module.scss';
import { GetClientDetailsFormTID } from './ClientDetailsForm.utils';
const clientDetailsFormTextsPath = 'components.clientDetailsForm';
export function ClientDetailsForm(param) {
    let { testId = 'client-details-form' } = param;
    const { t } = useLocaleKeys(clientDetailsFormTextsPath);
    const { control } = useFormContext();
    const { ClientDetailsFormTestIds } = useMemo(()=>GetClientDetailsFormTID(testId), [
        testId
    ]);
    const clientTypeOptions = useMemo(()=>[
            {
                value: 'business',
                label: t.businessType(),
                testId: ClientDetailsFormTestIds.ClientTypeOption('business')
            },
            {
                value: 'individual',
                label: t.individualType(),
                testId: ClientDetailsFormTestIds.ClientTypeOption('individual')
            }
        ], [
        t,
        ClientDetailsFormTestIds
    ]);
    return /*#__PURE__*/ _jsxs(Column, {
        gap: 16,
        className: styles.container,
        testId: ClientDetailsFormTestIds.Root(),
        children: [
            /*#__PURE__*/ _jsxs(Row, {
                gap: 16,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph2",
                        weight: "bold",
                        children: t.clientTypeLabel()
                    }),
                    /*#__PURE__*/ _jsx(Box, {
                        className: styles.clientTypeControl,
                        children: /*#__PURE__*/ _jsx(Controller, {
                            control: control,
                            name: "clientType",
                            render: (param)=>{
                                let { field } = param;
                                return /*#__PURE__*/ _jsx(SegmentControl, {
                                    options: clientTypeOptions,
                                    value: field.value,
                                    onChange: field.onChange,
                                    "aria-label": t.clientTypeLabel(),
                                    testId: ClientDetailsFormTestIds.ClientTypeControl(),
                                    bi: {
                                        name: 'client_type'
                                    }
                                });
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Controller, {
                control: control,
                name: "name",
                rules: requiredValidation(t.nameRequiredError()),
                render: (renderProps)=>/*#__PURE__*/ _jsx(TextField, _object_spread_props(_object_spread({}, connectControllerToTextField(renderProps)), {
                        label: t.nameLabel(),
                        testId: ClientDetailsFormTestIds.Name(),
                        bi: {
                            name: 'client_name'
                        }
                    }))
            })
        ]
    });
}
